<script>
/* eslint-disable */
import cities from "@/assets/json/addressData.json";
export default {
	name: "reserve",
	props: {
		isActiveReserve: {
			type: Boolean,
			required: true,
		},
		isActiveRuleFromReserve: {
			type: Boolean,
			required: true,
		},
		isActiveListFromReserve: {
			type: Boolean,
			required: true,
		},
		reserveStatus: {
			type: String,
			required: true,
		},
		reserve_use_info: {
			type: Boolean,
			required: true,
		},
		reserve_list: {
			type: Boolean,
			required: true,
		},
		carData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			userInfo: {
				gender: "",
				age: "",
				countyIndex: "請選擇縣市",
				districtIndex: "請選擇區域",
				mode: "",
				brand: "",
				currentcar: "",
			},
			previewInfo: {
				series: "",
				model_name: "",
				payment: "$30,000",
				mode: "",
				name: "",
				gender: "",
				age: "",
				pid: "",
				address: "",
				dealer: "",
				brand: "",
				currentcar: "",
			},
			areas: [],
			isCheck: false,
			isLockBtn: false,
		};
	},
	computed: {
		hostUrl() {
			return this.$store.state.hostUrl;
		},
		cities() {
			return cities;
		},
		allAge() {
			return this.$store.state.allAge;
		},
		allBrand() {
			return this.$store.state.allBrand;
		},
	},
	mounted() {
		let vm = this;

		vm.$nextTick(function () {
			vm.$store.dispatch("GETALLAGE");
			vm.$store.dispatch("GETALLBRAND");
			vm.onCountyChange();

			const element = document.getElementById("pid");
			if (element) {
				element.addEventListener(
					"blur",
					function () {
						element.value = vm.userInfo.pid.toUpperCase();
					},
					false,
				);
			}
		});
	},
	methods: {
		gtag(target) {
			let vm = this;

			switch (target) {
				case "return":
					vm.$gtag.event("CLICK", {
						event_category: "click",
						event_label: `Click_${vm.carData.car.no}_order_return`,
						send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
					});
					break;
			}
		},
		onCountyChange() {
			let vm = this;
			if (vm.cities.length > 0) {
				vm.cities.forEach((element, index) => {
					if (element.name === vm.userInfo.countyIndex) {
						vm.areas = vm.cities[index].areas;
						vm.userInfo.districtIndex = vm.cities[index].areas[0].name;
					}
				});
			}
		},
		onBrandChange() {
			// console.log("onBrandChange")
			let vm = this;
			vm.userInfo.currentcar = vm.allBrand[vm.userInfo.brand][0];
		},
		sendForm() {
			// console.log("sendForm")
			let vm = this;
			if (!vm.isCheck) {
				alert("請勾選確認以上資料皆正確無誤");
			} else {
				vm.isLockBtn = true;
				document.getElementById("form").submit();
				vm.$gtag.event("event", {
					event_category: "conversion",
					send_to: "AW-451827930/LF33CMvMvoYYENqxudcB",
				});
				vm.$gtag.event("CLICK", {
					event_category: "click",
					event_label: `Click_${vm.carData.car.no}_order_pay`,
					send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
				});
				// fbq('track', 'Purchase');
				_lt(
					"send",
					"cv",
					{
						type: "CarOrdered",
					},
					["f318243c-e326-4eae-ab95-2a016ce79687"],
				);
			}
		},
		checkForm() {
			// console.log("checkForm")
			let vm = this;

			vm.$gtag.event("CLICK", {
				event_category: "click",
				event_label: `Click_${vm.carData.car.no}_order_submit`,
				send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
			});

			if (!vm.userInfo.lastname) {
				alert("請填寫您的姓氏");
				const element =
					document.querySelector(".reserve-box #lastname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.firstname) {
				alert("請填寫您的名字");
				const element =
					document.querySelector(".reserve-box #firstname").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.gender) {
				alert("請選擇您的稱謂");
				const element =
					document.querySelector(".reserve-box #gender").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.age) {
				alert("請選擇您的年齡");
				const element =
					document.querySelector(".reserve-box #age").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.pid) {
				alert("請填寫您的身分證號碼");
				const element =
					document.querySelector(".reserve-box #pid").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validPId = /^[A-Za-z][12]\d{8}$/;
				if (!validPId.test(vm.userInfo.pid)) {
					alert("身分證號碼格式錯誤");
					return false;
				}
			}
			if (!vm.userInfo.mobile) {
				alert("請填寫您的手機號碼");
				const element =
					document.querySelector(".reserve-box #mobile").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validMobile = /^09\d{8}$/;
				if (!validMobile.test(vm.userInfo.mobile)) {
					alert("手機號碼格式錯誤");
					return false;
				}
			}
			if (vm.userInfo.countyIndex === "請選擇縣市") {
				alert("請選擇縣市");
				const element =
					document.querySelector(".reserve-box #county").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.address_detail) {
				alert("請填寫您的詳細地址");
				const element = document.querySelector(".reserve-box #address_detail").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.email) {
				alert("請填寫您的E-mail");
				const element =
					document.querySelector(".reserve-box #email").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			} else {
				let validEmail =
					/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
				if (!validEmail.test(vm.userInfo.email)) {
					alert("E-mail格式錯誤");
					return false;
				}
			}
			if (!vm.userInfo.mode) {
				alert("請選擇預計購車方式");
				const element =
					document.querySelector(".reserve-box #mode").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.brand) {
				alert("請選擇現有車款品牌");
				const element =
					document.querySelector(".reserve-box #brand").parentNode.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.userInfo.currentcar && vm.allBrand[vm.userInfo.brand].length > 0) {
				alert("請選擇現有車款");
				const element = document.querySelector(".reserve-box #currentcar").parentNode
					.previousSibling;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}

			if (!vm.reserve_list) {
				alert(
					"請點擊展開詳讀BMW 線上預訂條款與規則，並點選「同意條款」按鈕以完成此項目勾選",
				);
				const element = document.querySelector(".reserve-box #list").parentNode;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}
			if (!vm.reserve_use_info) {
				alert("請點擊展開詳讀資料使用同意條款，並點選「同意條款」按鈕以完成此項目勾選");
				const element = document.querySelector(".reserve-box #use_info").parentNode;
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
				return false;
			}

			vm.previewData();
		},
		previewData() {
			// console.log("previewData")
			let vm = this;

			vm.previewInfo.series = vm.carData.car.series_name;
			vm.previewInfo.model_name = vm.carData.car.model_name;
			vm.previewInfo.mode = vm.userInfo.mode;

			let validName = /[a-zA-z]/;
			if (
				validName.test(vm.userInfo.lastname) == true &&
				validName.test(vm.userInfo.firstname) == true
			) {
				vm.previewInfo.name = vm.userInfo.firstname + " " + vm.userInfo.lastname;
			} else {
				vm.previewInfo.name = vm.userInfo.lastname + vm.userInfo.firstname;
			}

			if (vm.userInfo.gender == 1) {
				vm.previewInfo.gender = "先生";
			} else if (vm.userInfo.gender == 0) {
				vm.previewInfo.gender = "女士";
			}

			vm.previewInfo.age = vm.userInfo.age;
			vm.previewInfo.pid = vm.userInfo.pid;
			vm.previewInfo.address =
				vm.userInfo.countyIndex + vm.userInfo.districtIndex + vm.userInfo.address_detail;
			vm.previewInfo.dealer = vm.carData.car.show_name;
			vm.previewInfo.brand = vm.userInfo.brand;
			vm.previewInfo.currentcar = vm.userInfo.currentcar;

			vm.$emit("update:reserveStatus", "preview");
			setTimeout(() => {
				document.getElementById("info").scrollTop = 0;
			}, 100);
		},
		backForm() {
			// console.log("backForm")
			let vm = this;
			vm.$emit("update:reserveStatus", "form");

			setTimeout(() => {
				const element = document.getElementById("reserve");
				element.scrollIntoView({
					behavior: "smooth",
					block: "nearest",
					inline: "nearest",
				});
			}, 100);

			vm.$gtag.event("CLICK", {
				event_category: "click",
				event_label: `Click_${vm.carData.car.no}_order_edit`,
				send_to: ["UA-124821034-1", "G-CYXF981YFQ"],
			});
		},
		reserveToggle() {
			// console.log("reserveToggle")
			let vm = this;
			vm.$emit("update:isActiveReserve", false);
			vm.$emit("update:reserveStatus", "form");
		},
		lightboxToggle(target) {
			// console.log("lightboxToggle",target)
			let vm = this;
			if (target === "list") {
				vm.$emit("update:isActiveListFromReserve", true);
			} else if (target === "rule") {
				vm.$emit("update:isActiveRuleFromReserve", true);
			}
		},
	},
};
</script>

<template src="./template.pug" lang="pug"></template>
<style src="./style.sass" lang="sass" scoped>
@import "@/assets/sass/_variable.sass"
@import "@/assets/sass/_mixin.sass"
</style>
